import Block from './Block'
import gsap from 'gsap'

export default class Timeline extends Block {
  getElems() {
    this.slider = this.el
    this.slidesContainer = this.el.querySelector('.b-timeline__slides')
    this.slides = Array.from(this.el.querySelectorAll('.b-timeline__slides__slide'))
    this.paginationYears = Array.from(this.el.querySelectorAll('.b-timeline__pagination__year'))
    this.prevBtn = this.el.querySelector('.prev')
    this.nextBtn = this.el.querySelector('.next')
    this.activeSlideIndex = 0
    this.autoSlideTimer = null
  }

  bindMethods() {
    this._updateSlider = this._updateSlider.bind(this)
    this._onYearClick = this._onYearClick.bind(this)
    this._startAutoSlide = this._startAutoSlide.bind(this)
    this._resetAutoSlideTimer = this._resetAutoSlideTimer.bind(this)
    this._updateProgressBar = this._updateProgressBar.bind(this)
  }

  init() {
    this._updateSlider(0)
    this._startAutoSlide()
  }

  events() {
    this.prevBtn.addEventListener('click', () => {
      this._resetAutoSlideTimer()

      const newIndex = (this.activeSlideIndex - 1 + this.slides.length) % this.slides.length

      this._updateSlider(newIndex)
    })

    this.nextBtn.addEventListener('click', () => {
      this._resetAutoSlideTimer()

      const newIndex = (this.activeSlideIndex + 1) % this.slides.length

      this._updateSlider(newIndex)
    })

    this.paginationYears.forEach((year, index) => {
      year.addEventListener('click', () => {
        this._resetAutoSlideTimer()

        this._onYearClick(index)
      })
    })
  }

  _startAutoSlide() {
    this.autoSlideTimer = setInterval(() => {
      const newIndex = (this.activeSlideIndex + 1) % this.slides.length

      this._updateSlider(newIndex)
    }, 5000)

    this._updateProgressBar()
  }

  _resetAutoSlideTimer() {
    if (this.autoSlideTimer) {
      clearInterval(this.autoSlideTimer)
    }

    this.autoSlideTimer = null
    this._startAutoSlide()
  }

  _updateProgressBar() {
    this.paginationYears.forEach((year) => {
      const progress = year.querySelector('.progress')

      if (progress) {
        gsap.killTweensOf(progress)
        gsap.set(progress, { width: '0%' })
      }
    })

    const currentProgress = this.paginationYears[this.activeSlideIndex].querySelector('.progress')

    if (currentProgress) {
      gsap.to(currentProgress, {
        width: '100%',
        duration: 5,
        ease: 'linear'
      })
    }
  }

  _updateSlider(newIndex) {
    const oldIndex = this.activeSlideIndex

    this.activeSlideIndex = newIndex
  
    const isMobileOrTablet = window.innerWidth <= 1024

    const getVisibleYearsCount = () => {
      const width = window.innerWidth

      if (width <= 400) return 6
      if (width <= 500) return 7
      if (width <= 700) return 8
      if (width <= 825) return 10
      if (width <= 990) return 13
      if (width <= 1024) return 16

      return this.paginationYears.length
    }
  
    if (isMobileOrTablet) {
      if (newIndex === 0) {
        this.paginationYears.forEach((year) => {
          year.style.display = 'block';
        });
      }
  
      const visibleCount = getVisibleYearsCount()
      
      this.paginationYears.forEach((year, index) => {
        year.style.display = index >= this.paginationYears.length - visibleCount ? 'block' : 'none'
      })
  
      if (oldIndex !== newIndex) {
        this.paginationYears[oldIndex].style.display = 'none'
        this.paginationYears[oldIndex].classList.remove('--active')
      }
      this.paginationYears[newIndex].style.display = 'block'
      this.paginationYears[newIndex].classList.add('--active')
      this.slides[oldIndex].classList.remove('active')
      this.slides[newIndex].classList.add('active')
    } else {
      this.slides[oldIndex].classList.remove('active')
      this.paginationYears[oldIndex].classList.remove('--active')
      this.slides[newIndex].classList.add('active')
      this.paginationYears[newIndex].classList.add('--active')
    }
  
    gsap.to(this.slidesContainer, {
      x: `-${newIndex * 100}%`,
      duration: 0.5,
      ease: 'power2.inOut'
    })
  
    this._updateProgressBar()
  }

  _onYearClick(index) {
    if (index !== this.activeSlideIndex) {
      this._updateSlider(index)
    }
  }
}
